import { Bar, Line } from "react-chartjs-2";
import {
  Box,
  Card,
  CardContent,
  CardHeader,
  Divider,
  Typography,
  useTheme,
} from "@mui/material";
import { getColorByCount } from "../../utils/getGraphColor";
import { Chart, registerables } from "chart.js";
Chart.register(...registerables);

const TipeIncident = ({ data, year }) => {
  const theme = useTheme();

  const dataGraph = {
    datasets: [
      {
        data: data.map((dt) => dt.countData),
        label: year,
        backgroundColor: getColorByCount(data.length),
        barPercentage: 1,
        // barThickness: 12,
        borderRadius: 4,
        categoryPercentage: 0.5,
        // maxBarThickness: 10,
      },
    ],
    labels: data.map((dt) => dt.groupName),
  };

  const options = {
    animation: false,
    cornerRadius: 20,
    layout: { padding: 0 },
    legend: { display: false },
    maintainAspectRatio: true,
    responsive: true,
    indexAxis: "x",
    type: "bar",
    options: {
      indexAxis: "x",
    },
    yAxes: [
      {
        ticks: {
          fontColor: theme.palette.text.secondary,
        },
        gridLines: {
          display: false,
          drawBorder: false,
        },
      },
    ],
    xAxes: [
      {
        ticks: {
          fontColor: theme.palette.text.secondary,
          beginAtZero: true,
          min: 0,
        },
        gridLines: {
          borderDash: [2],
          borderDashOffset: [2],
          color: theme.palette.divider,
          drawBorder: false,
          zeroLineBorderDash: [2],
          zeroLineBorderDashOffset: [2],
          zeroLineColor: theme.palette.divider,
        },
      },
    ],

    plugins: {
      legend: {
        display: false,
      },
    },
  };

  return (
    <Card>
      <Typography textAlign={"center"} variant="body1" marginTop={3}>
        Tipe Incident
      </Typography>
      <CardContent>
        <Box
          sx={{
            height: 150,
            position: "relative",
          }}
        >
          <Bar data={dataGraph} options={options} />
        </Box>
      </CardContent>
    </Card>
  );
};

export default TipeIncident;
